var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "klient-item",
    "class": {
      'admin-client-item': _vm.role === 'alex_admin'
    }
  }, [_vm.role === 'alex_admin' || _vm.role === 'financnik' ? _c('lead-timeline', {
    attrs: {
      "profile-id": _vm.clientData.client_profile.id
    }
  }) : _vm._e(), _c('div', {
    staticClass: "klient-item-to-part"
  }, [_c('div', {
    staticClass: "client-summary"
  }, [_c('div', {
    staticClass: "klient-info-wrapper"
  }, [_c('div', {
    staticClass: "client-badges"
  }, [_vm.parsedSource.href || _vm.parsedSource.className === 'source-ads' ? _c('a', {
    staticClass: "source-badge",
    "class": _vm.parsedSource.className,
    attrs: {
      "href": _vm.parsedSource.href,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v(" " + _vm._s(_vm.parsedSource.label) + " ")]) : _vm._e(), _c('client-district-badges', {
    attrs: {
      "client": _vm.clientData
    }
  })], 1), _c('div', {
    staticClass: "client-identity-row",
    "class": {
      'client-identity-row--admin': _vm.role === 'alex_admin'
    }
  }, [_vm.role === 'alex_admin' ? _c('div', {
    staticClass: "assigned-broker"
  }, [_c('span', {
    staticClass: "identity-kicker"
  }, [_vm._v("Finančník")]), _c('div', {
    staticClass: "assigned-broker-avatar"
  }, [_c('broker-picker-handler', {
    attrs: {
      "rules": ['priority'],
      "broker-id": _vm.clientData.financnik,
      "client-info": _vm.clientData,
      "clients": "",
      "klient": ""
    }
  })], 1)]) : _vm._e(), _c('div', {
    staticClass: "client-copy"
  }, [_vm.role === 'alex_admin' ? _c('span', {
    staticClass: "identity-kicker"
  }, [_vm._v("Klient")]) : _vm._e(), _c('user-manager-handler', {
    attrs: {
      "rules": ['priority'],
      "client-info": _vm.clientData,
      "client": "",
      "clients": "",
      "telephone": ""
    }
  })], 1), _vm.showDayBadge && _vm.clientData.client_profile.registered_at ? _c('day-badge', {
    attrs: {
      "date": _vm.clientData.client_profile.registered_at
    }
  }) : _vm._e()], 1)])]), _c('div', {
    staticClass: "stages"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l(6, function (n) {
    return _c('span', {
      key: n,
      staticClass: "bar",
      "class": n <= _vm.getClientFlowCount() ? 'bar--active' : 'bar--inactive'
    });
  }), 0)]), _c('div', {
    staticClass: "div-block-94"
  }, [_c('div', {
    staticClass: "aktualizacia"
  }, [_c('span', {
    staticClass: "aktualizaciaLabel"
  }, [_vm._v(_vm._s(_vm.currentFlowLabel))]), _c('span', {
    staticClass: "aktualizaciaCas"
  }, [_vm._v(_vm._s(_vm.transformDate(_vm.clientFlowData.checked_at)))])]), !_vm.nextClientFlowItem.invalid ? _c('div', {
    staticClass: "task pointer",
    on: {
      "click": function click($event) {
        return _vm.toggleClientFlowOption(_vm.nextClientFlowItem, true);
      }
    }
  }, [_c('div', {
    staticClass: "task-copy"
  }, [_c('div', {
    staticClass: "task-kicker"
  }, [_vm._v("Nasledujúca úloha")]), _c('div', {
    staticClass: "task-label"
  }, [_c('transition', {
    attrs: {
      "name": "fade-slide",
      "mode": "out-in"
    }
  }, [_vm.showNextFlowLabel ? _c('span', {
    key: _vm.nextClientFlowItem.display_name
  }, [_vm._v(" " + _vm._s(_vm.nextClientFlowItem.display_name.includes("Kontaktovaný") ? "Kontaktovať" : _vm.nextClientFlowItem.display_name) + " ")]) : _vm._e()])], 1)]), _vm._m(0)]) : _c('div')])]), _vm.notesWithFutureReminder.length > 0 ? _c('div', {
    staticClass: "notes-wrapper"
  }, _vm._l(_vm.notesWithFutureReminder, function (note, index) {
    return _c('div', {
      key: index,
      staticClass: "lastnote"
    }, [_c('span', {
      staticClass: "mr-3"
    }, [_vm._v(" " + _vm._s(_vm.formatDateDDMMYYYY(note.notify_date)) + " ")]), _c('span', [_vm._v(" " + _vm._s(note.note) + " ")])]);
  }), 0) : _vm._e(), _vm.clientData.sent_latest_message ? _c('div', {
    staticClass: "lastmessage",
    on: {
      "click": _vm.openClientChatPopUp
    }
  }, [_vm.clientData.sent_unread_messages ? _c('div', {
    staticClass: "badge"
  }, [_c('div', {
    staticClass: "text-block-13"
  }, [_vm._v(" " + _vm._s(_vm.clientData.sent_unread_messages) + " ")])]) : _vm._e(), _c('div', [_vm._v(" " + _vm._s(_vm.clientData.sent_latest_message) + " ")])]) : _vm._e()], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "task-complete",
    attrs: {
      "title": "Označiť úlohu ako dokončenú"
    }
  }, [_c('span', {
    staticClass: "task-check"
  }, [_vm._v("✓")])]);

}]

export { render, staticRenderFns }